import React from "react";
import PropTypes from "prop-types";
import useEventbrite from './useEventbrite';

// Adds eventbrite code to the page (unless it's already been added).
// Handles opening the eventbrite modal.
// This is needed in cases where the button is inside of an AJAX tab element.
const EventbriteModalButton = (props) => {
  const handleOrderCompleted = React.useCallback(() => {
    console.debug('Order was completed successfully');
  }, []);

  const modalButtonCheckout = useEventbrite({
    eventId: props.eventId,
    modal: true,
    onOrderComplete: handleOrderCompleted,
  });

  const id = modalButtonCheckout?.id;

  return id ? <button id={id} className="m-button m-button--block" type="button">{props.label || "Get Tickets"}</button> : null;
}

const Props = {
  eventId: PropTypes.string,
}

EventbriteModalButton.propTypes = Props;

export default EventbriteModalButton;